module.exports = __webpack_public_path__ + "media/images/img_plus-designer-bd3407003ff1e17ee01691ce3684c6c1.png";